import type { SiteScrollBlockerRefs } from './types'
import { getSiteFeatureBoundRefProvider } from '../../utils/refProvider'

const featureName = 'siteScrollBlocker'
const siteScrollBlockerRefProvider = getSiteFeatureBoundRefProvider(featureName)

const siteScrollBlockerRefs: SiteScrollBlockerRefs = {
	setSiteScrollingBlocked: () => siteScrollBlockerRefProvider(['setSiteScrollingBlocked']),
	isScrollingBlocked: () => siteScrollBlockerRefProvider(['isScrollingBlocked']),
}

export { siteScrollBlockerRefs }
